import { render, staticRenderFns } from "./DailyCheckFreeCommentSnapIndex.vue?vue&type=template&id=3254059a&"
import script from "./DailyCheckFreeCommentSnapIndex.vue?vue&type=script&lang=js&"
export * from "./DailyCheckFreeCommentSnapIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports